var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDressCirclesM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 170,
    viewBox: "0 0 122 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.48,
    cy: 110.48,
    r: 59.48,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.479,
    cy: 110.48,
    r: 52.045,
    fill: "#FFFFF6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.481,
    cy: 110.48,
    r: 44.61,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.48,
    cy: 110.48,
    r: 37.175,
    fill: "#FFFFF6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.478,
    cy: 110.48,
    r: 29.74,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.481,
    cy: 110.48,
    r: 22.305,
    fill: "#FFFFF6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.675,
    cy: 40.675,
    r: 40.675,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.6766,
    cy: 40.6746,
    r: 35.5906,
    fill: "#FFFFF6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.6742,
    cy: 40.6752,
    r: 30.5062,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.6758,
    cy: 40.6748,
    r: 25.4219,
    fill: "#FFFFF6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.6734,
    cy: 40.6754,
    r: 20.3375,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.675,
    cy: 40.675,
    r: 15.2531,
    fill: "#FFFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDressCirclesM);
export default __webpack_public_path__ + "static/media/viewDressCirclesM.3ed449489065ff4c2b8f0e6af72cd516.svg";
export { ForwardRef as ReactComponent };